import { createTriggerCharExtension } from "../extensions/trigger-char"

export const HelpArticleTriggerExtension = createTriggerCharExtension({
	name: "help-article-trigger",
	char: "@",
	eventName: "open-help-articles",
})
